/**
 * Card.tsx
 * Composant carte réutilisable avec header, body et footer optionnels
 * Utilise Tailwind CSS pour le styling
 */
import React from 'react';
import { cn } from '../utils/cn';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  shadow?: 'none' | 'sm' | 'md' | 'lg';
}

const paddingClasses = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6',
};

const shadowClasses = {
  none: '',
  sm: 'shadow-sm',
  md: 'shadow-md',
  lg: 'shadow-lg',
};

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ header, footer, padding = 'md', shadow = 'sm', className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'bg-white rounded-lg border border-gray-200',
          shadowClasses[shadow],
          className
        )}
        {...props}
      >
        {header && (
          <div className={cn('border-b border-gray-200', paddingClasses[padding])}>{header}</div>
        )}
        <div className={cn(header && footer ? paddingClasses[padding] : paddingClasses[padding])}>
          {children}
        </div>
        {footer && (
          <div className={cn('border-t border-gray-200', paddingClasses[padding])}>{footer}</div>
        )}
      </div>
    );
  }
);

Card.displayName = 'Card';
